import { Box, Text, Grid, useToast, Heading, Image, Button } from '@chakra-ui/react'
import { StarterComponent } from './StarterComponent.jsx'
import { useNavigate } from 'react-router-dom';
import { starter_products } from './starter_Data.js'
import { useState } from 'react';
import left from '../../assets/left.png'
import right from '../../assets/right.png'


export const Starter = () => {
    const linear = 'linear-gradient(30deg, rgb(128, 0, 255), rgb(130, 5, 255), rgb(131, 9, 255), rgb(133, 14, 255), rgb(135, 18, 255), rgb(136, 23, 255), rgb(138, 27, 255), rgb(139, 32, 254), rgb(141, 36, 254), rgb(143, 41, 254), rgb(144, 45, 254), rgb(146, 50, 254), rgb(148, 55, 254), rgb(149, 59, 254), rgb(151, 64, 254), rgb(152, 68, 254), rgb(154, 73, 254), rgb(156, 77, 254), rgb(157, 82, 254), rgb(159, 86, 253), rgb(161, 91, 253), rgb(162, 95, 253), rgb(164, 100, 253), rgb(165, 104, 253), rgb(167, 109, 253), rgb(167, 109, 253), rgb(166, 105, 252), rgb(166, 100, 251), rgb(165, 96, 250), rgb(164, 91, 249), rgb(163, 87, 248), rgb(163, 82, 247), rgb(162, 78, 246), rgb(161, 73, 245), rgb(160, 69, 244), rgb(160, 64, 243), rgb(159, 60, 242), rgb(158, 55, 241), rgb(157, 51, 239), rgb(157, 46, 238), rgb(156, 42, 237), rgb(155, 37, 236), rgb(154, 33, 235), rgb(154, 28, 234), rgb(153, 24, 233), rgb(152, 19, 232), rgb(151, 15, 231), rgb(151, 10, 230), rgb(150, 6, 229), rgb(149, 1, 228))'
    const navigate = useNavigate()
    const [path, setPath] = useState(0);

    const handleLeft = () => {
        let value = path - 1
        if (value == -1) {
            setPath(starter_products.length - 1)
        } else if (value == starter_products.length) {
            setPath(0)
        } else {
            setPath(value)
        }
    }

    const handleRight = () => {
        let value = path + 1
        if (value == 0) {
            setPath(0)
        } else if (value == starter_products.length) {
            setPath(0)
        } else {
            setPath(value)
        }
    }


    return (
        <Box>
            {/* navbar */}
            <Box w={['95%']} m={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} p={'10px'}>
                <Box display={'flex'} gap={'7px'}>
                    <Text color={'#AB47BC'} fontSize={'25px'} fontWeight={'bold'}>|| Dev</Text>
                    <Text color={'#9E9E9E'} fontSize={'25px'} fontWeight={'bold'}>Free</Text>
                </Box>
            </Box>

            {/* banner */}
            <Box textAlign={'center'} mt={['1.5cm', '2cm', '2cm']} mb={'1cm'}>
                <Box color={'#424242'} fontSize={['30px', '40px', '50px']} fontWeight={'medium'} display={'flex'} justifyContent={'center'}>
                    <Text>Free</Text>
                    <Text ml={'10px'} color={'#AB47BC'}>Dev</Text>
                    <Text>eloper Tools</Text>
                </Box>
                <Text color={'#616161'} fontSize={['20px']}>Made for you</Text>
            </Box>

            {/* content */}
            <Box bg={linear} p={'1cm 0'} borderRadius={'20px 20px 0 0'}>

                {/* section 1 */}
                <Box w={['95%', '90%', '67%']} display={['none', 'flex', 'flex', 'flex']} justifyContent={'space-between'} alignItems={'center'} m={'auto'}>
                    {starter_products && starter_products?.map((ele, index) => (
                        <Box fontSize={['14px', '15px', '17px']} w={'100%'} h={['70px', '80px', '100px']} key={index} onClick={() => setPath(index)} color={path == index ? '#AB47BC' : '#616161'} bg={path == index ? '#fed0ff' : 'white'} cursor={'pointer'} m={['0 7px', '0 10px', '0 10px']} fontWeight={'medium'} fontFamily={'sans-serif'} outline={'2px solid white'} outlineOffset={'5px'} _hover={{ outlineOffset: '6px' }} transition={'0.1s ease'} borderRadius={'15px'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                            {ele.title}
                        </Box>
                    ))}
                </Box>

                {/* section 2 */}
                <Box bg={'#e9dcf7'} w={['95%', '90%', '70%']} m={['0.7cm auto 1cm auto', '1.7cm auto 1cm auto', '1.7cm auto 1cm auto']} p={['10px', '20px', '20px']} display={'flex'} flexDirection={['column', 'column', 'column', 'row']} justifyContent={'space-between'} borderRadius={'10px'}>
                    <Box w={['100%', '100%', '100%', '50%']} p={'10px'} display={'flex'} flexDirection={'column'} justifyContent={'space-between'}>
                        <Box display={'flex'} alignItems={'center'} gap={'15px'}>
                            <Heading fontSize={'40px'} fontWeight={'bold'} color={'#6b2e6e'}>{starter_products[path]['title']}</Heading>
                            <Box onClick={() => navigate(starter_products[path]['url'])} cursor={'pointer'} w={'45px'} h={'45px'} bg={'white'} p={'10px'} borderRadius={'50%'} boxShadow={'rgba(0, 0, 0, 0.24) 0px 3px 8px'}><Image w={'100%'} src='https://cdn-icons-png.flaticon.com/128/2901/2901214.png' alt='opener' /></Box>
                        </Box>
                        <Box>
                            <Text fontSize={['16px', '17px', '18px']} m={['10px 0', '10px 0', '0']} color={'#757575'} fontFamily={'sans-serif'}>{starter_products[path]['description']}</Text>
                            <Box display={'flex'} flexDirection={['row-reverse','row-reverse','row']}>
                            <Box w={'150px'} mt={'20px'} mb={['10px','10px','0']} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                <Image onClick={handleLeft} cursor={'pointer'} w={'50px'} h={'50px'} p={'0px'} bg={'#AB47BC'} borderRadius={'50%'} boxShadow={'rgba(0, 0, 0, 0.24) 0px 3px 8px'} src={left} alt='left' />
                                <Image onClick={handleRight} cursor={'pointer'} w={'50px'} h={'50px'} p={'1.5px'} bg={'#AB47BC'} borderRadius={'50%'} boxShadow={'rgba(0, 0, 0, 0.24) 0px 3px 8px'} src={right} alt='right' />
                            </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Box w={['100%', '100%', '100%', '50%']} display={'flex'} justifyContent={['center', 'center', 'center', 'right']} alignItems={'center'}>
                        <Image onClick={() => navigate(starter_products[path]['url'])} cursor={'pointer'} bg={'white'} h={['auto','auto','400px']} borderRadius={'7px'} p={'15px'} src={starter_products[path]['image']} alt='pic' boxShadow={'rgba(0, 0, 0, 0.24) 0px 3px 8px'} />
                    </Box>
                </Box>

            </Box>
        </Box>
    );
};

// <style>{`::-webkit-scrollbar {display: none}`}</style>